import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { env } from '../../../environments/environment';

@Injectable({
  providedIn: 'root'
})
export class MediaService {

  constructor(private http: HttpClient) { }

  getMedia(dataSrc: any): Observable<any> {
    const params = new HttpParams().set("mediaPath", dataSrc);
    const headers = new HttpHeaders().set('no-spinner', 'true');
    return this.http.get(env.API.get_media_url, { params, headers });
  }

}
